/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Icon, Button, Header, Form, Modal } from 'semantic-ui-react'

import NameField from '../fields/nameField'
import PhoneField from '../fields/phoneField'
import CommissionField from '../fields/feeRateField'
import RadiusField from '../fields/radiusField'
import PackageField from '../fields/packageField'
import RegionField from '../fields/regionField'
import StatusField from '../fields/statusField'
import IdentityField from '../fields/idNumberField'
import AbaNameField from '../fields/abaNameField'
import AbaNumberField from '../fields/abaNumberField'
import MaxPayableField from '../fields/maxPayableField'

export default class DriverForm extends React.PureComponent {
  btnSubmitRef = React.createRef()

  onSave = e => {
    const { saveDriver } = this.props
    e.preventDefault()

    saveDriver()
  }

  render() {
    const { loading, onClose, visible, action, onFieldChange, driverData } = this.props

    return (
      <Modal open={visible} size="small" style={{ marginTop: 0 }}>
        <Header content={action === 'new' ? 'Add New Driver' : 'Edit Driver'} />
        <Modal.Content style={{ maxHeight: 500, overflow: 'auto' }} className="branch-form">
          <Form
            onSubmit={this.onSave}
            ref={ref => {
              this.formRef = ref
            }}
            disabled={loading}
          >
            <Form.Group widths="equal">
              <NameField
                onChange={onFieldChange}
                value={driverData.family_name}
                field="family_name"
                label="Family Name"
              />
            </Form.Group>
            <Form.Group widths="equal">
              <NameField
                onChange={onFieldChange}
                value={driverData.first_name}
                field="first_name"
                label="First Name"
              />
            </Form.Group>
            <Form.Group widths="equal">
              <PhoneField onChange={onFieldChange} value={driverData.tel} disabled={action === 'edit'} />
            </Form.Group>
            <Form.Group widths="equal">
              <CommissionField onChange={onFieldChange} value={driverData.delivery_fee_rate} />
            </Form.Group>
            <Form.Group widths="equal">
              <RadiusField onChange={onFieldChange} value={driverData.radius} />
            </Form.Group>
            <Form.Group widths="equal">
              <MaxPayableField onChange={onFieldChange} value={driverData.max_payable_amount} />
            </Form.Group>
            <Form.Group widths="equal">
              <PackageField onChange={onFieldChange} value={driverData.package_size} />
            </Form.Group>
            <Form.Group widths="equal">
              <RegionField onChange={onFieldChange} value={driverData.region} />
            </Form.Group>
            <Form.Group widths="equal">
              <StatusField onChange={onFieldChange} value={driverData.status} />
            </Form.Group>
            <Form.Group widths="equal">
              <IdentityField onChange={onFieldChange} value={driverData.identity_number} />
            </Form.Group>
            <Form.Group widths="equal">
              <AbaNameField onChange={onFieldChange} value={driverData.aba && driverData.aba.name} number={driverData.aba && driverData.aba.number} />
            </Form.Group>
            <Form.Group widths="equal">
              <AbaNumberField onChange={onFieldChange} value={driverData.aba && driverData.aba.number} name={driverData.aba && driverData.aba.name} />
            </Form.Group>
            <button
              type="submit"
              hidden
              ref={ref => {
                this.btnSubmitRef = ref
              }}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose} disabled={loading}>
            Close
          </Button>
          <Button
            icon
            color="black"
            onClick={() => this.btnSubmitRef.click()}
            loading={loading}
            disabled={loading}
          >
            <Icon name="checkmark" /> Save
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/forms/driverForm.js